<template>
  <TText size="base" variant="semibold" classes="mb-2" tag="h3">
    {{ item.title }}
  </TText>

  <TProse :full-width="false" :responsive="false">
    <ul>
      <li
        v-for="(characteristic, indexCharacteristic) in item.list"
        :key="indexCharacteristic"
      >
        {{ characteristic.name }}
      </li>
    </ul>
  </TProse>
</template>

<script setup lang="ts">
interface propsInterface {
  item: {
    title: string
    list: Array<{
      name: string
    }>
  }
}

defineProps<propsInterface>()
</script>
